module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a9-3-a40e2ec07890ad89c2db6b9f17b151b9.jpg";